/*
 * @Author: Charles Zhang
 * @Date: 2021-02-21 11:04:52
 * @Last Modified by: Charles Zhang
 * @Last Modified time: 2021-02-24 16:51:13
 */

import React from "react";
// reactstrap components
import {
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";

class SimpleFooter extends React.Component {
  render() {
    return (
      <div>
        <footer  className=" footer">
          <Container>
            <hr />
            <Row className=" align-items-center justify-content-md-between">
              <Col md="6">
                <div className=" copyright">
                  © {new Date().getFullYear()}{" "}
                  <a
                    href="https://www.educg.net"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    希冀-信息类专业教学与科研一体化平台
                  </a>
                </div>
              </Col>
              <Col md="6">
                <Nav className=" nav-footer justify-content-end">
                  <NavItem>
                    <NavLink
                      href="https://www.educg.net"
                      target="_blank"
                    >
                      希冀-信息类专业教学与科研一体化平台
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="https://devms.t.educg.com/#/zl"
                      target="_blank"
                    >
                      联系我们
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="https://www.educg.net/about.html"
                      target="_blank"
                    >
                      关于我们
                    </NavLink>
                  </NavItem>
                  {/*<NavItem>*/}
                  {/*  <NavLink*/}
                  {/*    href="http://blog.creative-tim.com?ref=adsr-footer"*/}
                  {/*    target="_blank"*/}
                  {/*  >*/}
                  {/*    Blog*/}
                  {/*  </NavLink>*/}
                  {/*</NavItem>*/}
                  {/*<NavItem>*/}
                  {/*  <NavLink*/}
                  {/*    href="https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md"*/}
                  {/*    target="_blank"*/}
                  {/*  >*/}
                  {/*    MIT License*/}
                  {/*  </NavLink>*/}
                  {/*</NavItem>*/}
                </Nav>
              </Col>
            </Row>
          </Container>
        </footer>
      </div>
    );
  }
}

export default SimpleFooter;
